import React, { Component } from 'react';
import MerchantList from '../MerchantList/MerchantList'

const fetchData = function(){

}


class StudentProfile extends Component {
    
    constructor(props) {
        super(props);
    }
    state = {
        loading: true
    }

    componentDidMount() {
        
        const url = 'https://api.glippy.com/v1/profile';
        const that = this;

        fetch(url, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-User-Email':'test@test.com',
                    'X-User-Token':'g14NHohYNLouJ6HxdYor',
                },
            })
        .then((response) => {
            return response.json();
        })
    
        .then((data) => {
            this.setState({
                data: data,
                loading:false
            })
        })
        .catch((error) => console.log(error));
    }

    render(){
        return (
            
        this.state.loading ? <div className="loading">loading</div> :

        <div className="profile-wrapper">
            <div className="welcome-message">
                Welcome Student
            </div>
            <div className="discount-status-card">
                <div className="discount-status-card-org-wrapper">
                    <img className="discount-org-logo" src={this.state.data.org_logo_url}  alt="Smiley face" />
                    <div className="discount-program-wrapper">
                        <div className="discount-org-name">
                        {this.state.data.organization}
                        </div>
                        <div className="discount-program">
                        Student Reward Program
                        </div>
                    </div>
                </div>
                <div className="discount-status-bar">
                    <div className="discount-status-text">
                        Thank you for being a great student and achieving <span style={{ textTransform: "capitalize", fontWeight: "bolder" }}>{this.state.data.award_level} Level </span> 
                    </div>
                </div>
                </div>
            <div className="rewards-list-header">
                Your Rewards
            </div>
            {this.state.data ? <MerchantList data={this.state.data} /> : "" }             
        </div>
        )
    }
}

export default StudentProfile;



// WEBPACK FOOTER //
// ./src/components/StudentProfile/StudentProfile.js